import {
  LendHistory,
  LendHistoryFromJSON,
  SearchLendHistoriesRequest,
  SearchLendHistoriesRequestToJSON,
  HTTPQuery,
  SearchBorrowHistoriesRequest,
  BorrowHistory,
  SearchBorrowHistoriesRequestToJSON,
  BorrowHistoryFromJSON
} from '@/api'
import * as runtime from '../runtime'

export class InterLibraryLoanApi extends runtime.BaseAPI {
  /**
   * 貸出履歴を検索する
   * 貸出履歴検索
   */
  async searchLendHistories(
    request: SearchLendHistoriesRequest
  ): Promise<LendHistory[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchLendHistoriesRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      '/interlibrary-loan/lend-histories',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(LendHistoryFromJSON)
    ).value()
  }

  /**
   * 借用履歴を検索する
   * 借用履歴検索
   */
  async searchBorrowHistories(
    request: SearchBorrowHistoriesRequest
  ): Promise<BorrowHistory[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchBorrowHistoriesRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      '/interlibrary-loan/borrow-histories',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BorrowHistoryFromJSON)
    ).value()
  }
}
